import { IIconProps } from "../types"

export default function IconLR6(props: IIconProps) {
  const width = props.size || props.width || 93
  const height = props.size || props.height || 72
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.86692 8.19922C6.49692 5.39922 8.70691 3.64922 11.7369 2.40922C14.7569 1.16922 18.6069 0.449219 22.3469 0.449219C26.0869 0.449219 29.7369 1.16922 33.1569 2.04922C36.5669 2.92922 39.7669 3.96922 42.9569 4.51922C46.1469 5.07922 49.3369 5.13922 52.5569 4.84922C55.7769 4.55922 59.0369 3.90922 61.8969 3.31922C64.7669 2.72922 67.2369 2.20922 69.9669 2.33922C72.7069 2.46922 75.6969 3.25922 78.5669 4.29922C81.4269 5.33922 84.1669 6.63922 86.4769 8.32922C88.7869 10.0292 90.6769 12.1092 91.3569 18.6792C92.0369 25.2592 91.5169 36.3292 90.4769 44.7292C89.4369 53.1292 87.8769 58.8492 86.0469 62.1392C84.2269 65.4292 82.1469 66.2792 78.1069 67.0592C74.0669 67.8392 68.0869 68.5592 59.6169 69.2692C51.1569 69.9892 40.2169 70.6992 32.5369 70.6992C24.8569 70.6992 20.4269 69.9892 17.1369 68.9492C13.8469 67.8992 11.6969 66.5392 9.81692 63.9292C7.92692 61.3292 6.29692 57.4892 4.63692 51.8592C2.97692 46.2192 1.28692 38.7992 0.696916 32.9792C0.116916 27.1492 0.636916 22.9192 1.41692 18.8792C2.19692 14.8392 3.23692 10.9992 4.86692 8.19922Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M50.9278 4.96875C51.4578 15.5987 51.9878 26.2187 52.0278 31.6987C52.0678 37.1787 51.6078 37.4987 48.9378 39.3587C46.2778 41.2087 41.3878 44.5987 36.5078 47.9787"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M51.7578 36.1094C56.7678 38.9594 61.7678 41.8094 66.7778 44.6594"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
